// extracted by mini-css-extract-plugin
module.exports = {"form":"Filters_form__wnalZ","categories":"Filters_categories__7bDk5","category":"Filters_category__3uBpK","label":"Filters_label__iWORc","icon":"Filters_icon__YP40E"};